/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface LinkArrowProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const LinkArrow: React.SFC<LinkArrowProps> = ({size, ...props}) => (
  <svg viewBox="0 0 22 11" fill="currentColor" width={ size || "22" } height={ size || "11" } {...props}>
    <g stroke="currentColor" fill="none" strokeWidth="1.5" fillRule="evenodd">
      <path transform="rotate(45 15 6.707)" d="M11 2.02904564L18 2 17.9709544 9" />
      <path d="M18.688 5.5L0.5 5.5" transform="translate(1)" strokeLinecap="square" className="link-arrow-shaft" />
    </g>
  </svg>
);
LinkArrow.displayName = 'LinkArrow';
export default LinkArrow;
/* tslint:enable */
/* eslint-enable */
